export default "__VITE_ASSET__Crxw3jKv__"